"use strict";
var text = require("app/util/formatter/text.js");
var currency = require("app/util/formatter/currency.js");
var moment = require("moment-timezone");

var PlanCardPrice = React.createClass({
  mixins: [ReactIntl.IntlMixin],

  propTypes: {
    priceValue: React.PropTypes.number.isRequired,
    defaultValue: React.PropTypes.number,
    discountExpiringTime: React.PropTypes.string
  },

  getPriceMessages: function() {
    var price = this.getIntlMessage("pricing.price.value");
    var formattedPrice = currency.valueToViewFormat(this.props.priceValue || 0);
    formattedPrice = currency.formatInteger(formattedPrice);
    var currencyText = this.formatMessage(price, {priceValue: formattedPrice});

    var month = this.getIntlMessage("pricing.price.month");

    var formattedExpiringDate;

    if(this.props.discountExpiringTime) {
      var expiringDate = this.getIntlMessage("pricing.price.discount_expiring");
      formattedExpiringDate = this.formatMessage(expiringDate, {
        expiringDate:  moment.tz(this.props.discountExpiringTime, "UTC").format("DD/MM/YYYY")
      });
    }

    var formattedDefaultValue = currency.valueToViewFormat(this.props.defaultValue);
    formattedDefaultValue = currency.formatInteger(formattedDefaultValue);

    return {
      price: currencyText,
      month: month,
      expiringDate: formattedExpiringDate,
      defaultValue: formattedDefaultValue
    };
  },

  render: function() {
    var priceMessages = this.getPriceMessages();
    var isDiscountApplied = this.props.defaultValue > this.props.priceValue;

    return (
      <div className="mt-20 planCard-darkBlue-color">
        {
          isDiscountApplied
          ? <PriceWithDiscount {...priceMessages} />
          : <PlanPrice {...priceMessages} />
        }
      </div>
    );
  }
});

const PriceWithDiscount = (props) => (
  <div>
    <div className="td-lt c-light-grayish-blue mb-5">
      De R$ {props.defaultValue}/ mês  por
    </div>
    <PlanPrice {...props}/>
    {props.expiringDate}
  </div>
);

const PlanPrice = (props) => (
  <div>
    <div className="fs-30">
    {props.price}
    <span className="fs-15">{props.month}</span>
    </div>
    <div className="d-b mt-5">
    </div>
  </div>
);

module.exports = PlanCardPrice;



// WEBPACK FOOTER //
// ./app/screens/Pricing/components/PlanSelector/plan-card-price.jsx